import { sourceIds } from './about.mdx';

export { sourceIds };
export const quickAnswer =
  '本站是独立玩家工具与攻略站。按资料来源核验事实，玩法建议与实测数据分开表述。';

## 关于本站

CONTROL Resonant Tools 是一个独立制作的《控制: 共振》（CONTROL Resonant）玩家工具与攻略站，重点解决配装规划、谜题答案、能力选择、任务卡点和奖杯解法。

## 我们如何核实内容

官方资料用于版本和系统说明，公开攻略用于核对具体机关与任务步骤。详情页列出来源与核验日期。中文稿采用本地搜索与阅读习惯，不把未经核实的英文术语意译冒充官方技能译名。

核验顺序为 Remedy 官方资料、PlayStation / Steam 官方中文资料、游戏内简体中文 UI、可靠专业攻略来源。社区讨论只作为辅助信号。无法确认的能力和系统名继续保留英文。

## 测试声明

没有经过本站实际游戏测试的内容，会按“根据已发布资料核实”表述，不声称亲自测试。

## 免责声明

本站为独立玩家项目，与 Remedy Entertainment 无隶属或官方合作关系。游戏名称、商标与其他知识产权属于各自权利人。

## 原创与工具边界

本站使用原创文字和原创示意图，不复制第三方截图或歌词。技能建议说明玩法取舍，不提供未经实测的伤害、DPS 或评分。配装工具不读取账号和游戏存档。

## 联系与纠错

发现错误时，请发送页面地址、游戏版本和问题描述至 [support@controlresonanttools.online](mailto:support@controlresonanttools.online)。关于分析脚本和数据处理，请阅读[隐私政策](/privacy-policy)。
